module.exports = __webpack_public_path__ + "img/bars-regular.02412963.svg";